// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"ytkKt","value":"FoveA","label":"hAmcD"};